/**
 * Production hosts for this app (from .iac go ingress):
 * - Stamp: fin-prequalifications-host.<stamp>.go.prod.financing.srv.servicetitan.com
 * - Vanity: go.servicetitan.com (path /prequalify)
 *
 * RUM stays off for qa/stage/next/practice (and local), matching auth-loader's
 * production-only gate.
 */
const PRODUCTION_STAMP_HOST =
  /^fin-prequalifications-host\.[^.]+\.go\.prod\.financing\.srv\.servicetitan\.com$/;
const PRODUCTION_VANITY_HOST = /^go\.servicetitan\.com$/;

export function isDatadogRumEnabled(hostname: string): boolean {
  return (
    PRODUCTION_STAMP_HOST.test(hostname) ||
    PRODUCTION_VANITY_HOST.test(hostname)
  );
}
